export default (destinationArray, sourceArray, options) => sourceArray;
